<template>
  <div class="csv-upload">
    <loading
      :active.sync="isUploadInProgress"
      :can-cancel="false"
      :is-full-page="true"
    />
    <main role="main">
      <div class="card_wrap">
        <!-- CSVアップロードタブの項目 -->
        <div class="csv-upload-tab">
          <csv-upload-tab-item
            v-for="csvUploadTab in visibleTabs"
            :key="csvUploadTab.csvNo"
            :csvType="csvUploadTab.label"
            :icon="require(`@/assets/images/${csvUploadTab.icon}`)"
            :csvNo="csvUploadTab.csvNo"
            :isActive="csvUploadActiveTab === csvUploadTab.csvNo"
            @update-active-tab="updateCsvActiveTab"
          />
        </div>
        <!-- アップロードテーブルエリア -->
        <div class="csv-upload-table" v-show="isShowUploadTable()">
          <table class="table upload_table">
            <thead>
              <tr>
                <th>
                  <span>
                    ファイル名
                    <img v-if="csvUploadActiveTab === 'default'"
                      v-b-tooltip.hover.top.html="{
                        variant: 'secondary',
                        animation: true
                      }"
                      title="例：[プレフィックス] [_任意文字].csv
                        <br /><br />
                        ファイル名はプレフィックス（t-Sort仕分けの設定＞データフォーマット設定で定義した文字）から始めてください。<br />
                        任意文字は省略可能です。複数設定も可能です。"
                      src="../assets/images/help_outline_gray_24dp.svg"
                      alt="Question mark"
                      class="question_mark"
                    />
                  </span>
                </th>
                <th v-if="isShowTaskTypeColumn">タスクタイプ</th>
                <th v-if="csvUploadActiveTab === 'default'">
                  <span>
                    プレフィックス（種類）
                    <img
                      v-b-tooltip.hover.top.html="{
                        variant: 'secondary',
                        animation: true
                      }"
                      title="t-Sort仕分けの設定＞データフォーマット設定で定義した文字です。<br />
                        ファイル名の先頭に入れる事でデータ種類を判別します。<br />
                        必ず、指定した文字を使用してください。"
                      src="../assets/images/help_outline_gray_24dp.svg"
                      alt="Question mark"
                      class="question_mark"
                    />
                  </span>
                </th>
                <th>
                  <span>
                    置き換え方式
                    <img
                      v-b-tooltip.hover.top.html="{
                        variant: 'secondary',
                        animation: true
                      }"
                      title="アップロードの登録方式です。"
                      src="../assets/images/help_outline_gray_24dp.svg"
                      alt="Question mark"
                      class="question_mark"
                    />
                  </span>
                </th>
                <th>ステータス</th>
                <th>取消</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(original, index) in originalFileData" :key="index">
                <td class="text-center">
                  <span class="file-name">
                    <span>{{ original.file.name }}</span>
                    <span class="file-error-text" v-if="original.isEmptyFile">
                      <span class="material-icons">report</span>ファイル内が空です。
                    </span>
                    <span class="file-error-text" v-else-if="original.isNotCsvFile">
                      <span class="material-icons">report</span>不明なファイル形式です。
                    </span>
                  </span>
                </td>
                <td class="task-type-column" v-if="isShowTaskTypeColumn">
                  <div v-if="filteredTaskTypeList.length === 0" class="text-center text-danger font-weight-bold"> 未登録 </div>
                  <form-select-component
                    v-else
                    :options="filteredTaskTypeList.map(field => field.value)"
                    :customLabel="opt => filteredTaskTypeList.find(field => field.value === opt).text"
                    v-model="original.taskType"
                  />
                </td>
                <td v-if="csvUploadActiveTab === 'default'"
                  :class="[
                    original.prefix === '不明'
                      ? 'text-center text-danger font-weight-bold'
                      : 'text-center'
                  ]"
                >
                  {{ original.prefix | mstTypeFormat(csvInfoData) }}
                </td>
                <td class="text-center">{{ original.prefix | formatReplacementValue(csvInfoData, replacementMethod, csvUploadActiveTab) }}</td>
                <td class="text-center">
                  <span
                    class="status d-flex align-items-center justify-content-center"
                    v-if="original.uploadStatus === -1"
                    v-bind:style="{
                      color: statusColor[original.uploadStatus]
                    }"
                    >
                      <span :class="[{'cursor-pointer': original.hasErrorDetail} , 'd-flex align-items-center']" v-if="original.hasErrorDetail" v-b-modal.modal-center>
                        <span class="material-icons material-icons-outlined report-icon">
                          report
                        </span>
                        <span class="d-flex">
                          {{ original.uploadStatus | uploadStatusMessage }}
                        </span>
                      </span>
                      <span class="d-flex align-items-center" v-else>
                        <span class="material-icons report-icon">
                          report
                        </span>
                        <span class="d-flex">
                          {{ original.uploadStatus | uploadStatusMessage }}
                        </span>
                      </span>
                      <span
                        class="material-symbols-outlined download-icon"
                        @click="onDownloadErrorFile"
                        v-if="isShowDownloadIcon"
                      >
                        file_download
                      </span>
                  </span>
                  <span
                    class="status"
                    v-bind:style="{
                      color: statusColor[original.uploadStatus]
                    }"
                    v-show="original.uploadStatus !== -1"
                    >
                      {{ original.uploadStatus | uploadStatusMessage }}
                  </span>
                </td>
                <td class="text-center">
                  <button
                    class="delete_circle_btn btn"
                    :class="{delete_hidden_btn : original.uploadStatus === 2 ||
                      original.uploadStatus === 1}"
                    :disabled="isUploadInProgress"
                    @click="confirmAndDeleteCsvFile(original.file)"
                  >
                    x
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="d-flex justify-content-center" v-if="isShowUploadButton()">
          <!-- アップロードボタン -->
          <button
            :class="[isUploadInProgress ? 'btn_gray_round' : 'btn_blue_round']"
            :disabled="isUploadInProgress"
            @click="processCsvUpload()"
          >
            <span>{{ isUploadInProgress ? 'アップロード中...' : 'アップロード' }}</span>
            <span class="material-icons material-icons-outlined">
              keyboard_arrow_right
            </span>
          </button>
        </div>
        <!-- CSV File ドラッグエリア -->
        <div
          :class="[{ '-drag': isDragCsvFile == 'new' }, 'upload-area', { 'mt-5': isShowUploadTable() }]"
          @dragover.prevent="processDragStatus($event, 'new', true)"
          @dragleave.prevent="processDragStatus($event, 'new', false)"
          @drop.prevent="onDropCsvFile"
        >
          <div class="drop">
            <img
              src="../assets/images/file_upload_icon.svg"
              alt="アップロードアイコン"
            />
            <p class="drag-drop-info">
              ドラッグ＆ドロップしてCSVファイルを選択してください
            </p>
            <p class="text_black mb-3">または</p>
            <p>
              <label for="corporation_file" class="text_blue upload_btn">
                <strong>ファイルを選択</strong>
                <input
                  type="file"
                  class="drop__input"
                  style="display: none"
                  id="corporation_file"
                  ref="fileInput"
                  multiple="multiple"
                  @change="onDropCsvFile"
                />
              </label>
              （複数選択可能）
            </p>
          </div>
        </div>
      </div>

      <!-- スタックトレースエラー モーダル -->
      <div>
        <b-modal
          id="modal-center"
          scrollable
          centered
          hide-footer
          size="lg"
          header-text-variant="gray1"
          header-class="pb-0 pt-1"
        >
          <h5 class="text-center mb-4">アップロードエラー</h5>
          <p
            class="errorMessage text-break"
            v-for="(msg, i) in errorConvert(errorMessages)"
            :key="i"
            :class="[{'d-flex': !i}]"
          >
            <br v-if="i == 2" />
            {{ msg | replaceMsg }}
            <span
              v-if="!i && isShowDownloadIcon"
              class="text-danger cursor-pointer d-flex align-items-center ml-1"
              @click="onDownloadErrorFile"
            >
              <span class="material-symbols-outlined">
                file_download
              </span>
              ダウンロード
            </span>
          </p>
        </b-modal>
      </div>
    </main>
  </div>
</template>

<script>
import FlashMessage from '../common/flash-message.component'
import AppConstants from '../constants/app.constants'
import RouterUtils from '../_helpers/router.util'
import Loading from 'vue-loading-overlay'
import { saveAs } from 'file-saver'
import HTTPClient from '../common/http-client'
import ErrorCdMsgConstants from '../constants/error-cd-msg.constants'
import ErrorMessageUtils from '../_helpers/error-message.util'
import FileReaderUtils from '../_helpers/file-reader.util'
import CsvUploadTabItem from './custom-components/CsvUploadTabItem'
import FormSelectComponent from './custom-components/FormSelectComponent.vue'
import { WorkInstructionFlag } from './../enums/work-instruction.enums'
import { CsvUploadType } from '../enums/csv-upload-type.enums.js'
import { store } from '@/store.js'
const UNSPECIFIED_FILE_NAME_PREFIX = '不明'
const UNDERSCORE = '_'
const CSV_FILE_EXTENSION = '.csv'
const CSV_EXTENSION_REGEX = /\.csv/i
const CSV_FILE_TYPE = 'text/csv'
const TASK_TYPE_DEFAULT = [-1, -2]
const CSV_UPLOAD_STATUS_INCOMPLETE = 0
const CSV_UPLOAD_STATUS_IMPORTING = 1
const CSV_UPLOAD_STATUS_SUCCESS = 2
const CSV_UPLOAD_STATUS_FAILED = -1
export default {
  components: {
    Loading,
    CsvUploadTabItem,
    FormSelectComponent,
    CsvUploadType
  },
  data() {
    return {
      statusColor: {
        '-1': '#B41B3E',
        0: '#252422',
        1: '#252422',
        2: '#252422'
      },
      csvInfoData: {},
      originalFileData: [],
      copyFiles: [],
      errorMessages: [],
      isUploadInProgress: false,
      isDragCsvFile: null,
      replacementMethod: '',
      isShowDownloadIcon: false,
      errCdsWithoutDetails: [
        ErrorCdMsgConstants.TOTAL_RECORDS_LIMIT_IN_DB_EXCEEDED_ERR_CD,
        ErrorCdMsgConstants.FILE_UPD_NAME_LENGTH_ERR_CD,
        ErrorCdMsgConstants.FILE_UPD_CSV_NO_UNKNOWN_ERR_CD
      ],
      csvUploadActiveTab: null,
      taskTypeList: [],
      filteredTaskTypeList: [],
      taskTypeSelectedList: [],
      isShowTaskTypeColumn: false
    }
  },

  filters: {
    mstTypeFormat(fileName, csvData) {
      return csvData[fileName] ? `${fileName} (${csvData[fileName].type})` : UNSPECIFIED_FILE_NAME_PREFIX
    },
    uploadStatusMessage(status) {
      const statusMessages = {
        [CSV_UPLOAD_STATUS_INCOMPLETE]: '未完了',
        [CSV_UPLOAD_STATUS_IMPORTING]: '取込中...',
        [CSV_UPLOAD_STATUS_SUCCESS]: '完了',
        [CSV_UPLOAD_STATUS_FAILED]: 'エラー'
      }
      return statusMessages[status]
    },
    replaceMsg(msg) {
      return msg ? msg.replace('<br/>', '') : msg
    },
    formatReplacementValue(prefix, csvData, replacementMethod, csvUploadActiveTab) {
      const isTaskCsvNo = csvData[prefix] && csvData[prefix].csvNo === CsvUploadType.TASK.csvNo
      return (csvUploadActiveTab === CsvUploadType.TASK.csvNo) || (csvUploadActiveTab === CsvUploadType.DEFAULT.csvNo && isTaskCsvNo) ? '-' : replacementMethod
    }
  },

  created() {
    this.getUpload()
    this.initActiveTab()
  },

  computed: {
    visibleTabs() {
      return Object.values(CsvUploadType).filter(tab => {
        return !(this.isOnlyNoTaskSortUseCase && AppConstants.NO_TASK_SORT_HIDDEN_LIST.includes(tab.csvNo))
      })
    }
  },

  methods: {
    /**
     * アクティブなタブを初期化します。
     */
    initActiveTab() {
      const csvActiveTabLocalStorage = JSON.parse(localStorage.getItem(AppConstants.STORAGE_CSV_UPLOAD_TAB_ACTIVE))
      const isValidTab = this.visibleTabs.some(tab => tab.csvNo === csvActiveTabLocalStorage)
      this.csvUploadActiveTab = isValidTab ? csvActiveTabLocalStorage : (this.visibleTabs[0] && this.visibleTabs[0].csvNo) || null
      if (!isValidTab) {
        localStorage.setItem(AppConstants.STORAGE_CSV_UPLOAD_TAB_ACTIVE, JSON.stringify(this.csvUploadActiveTab))
      }
      // CSVアップロードタブが 'task' または 'sorting' の場合にのみ、タスクタイプ列を表示する
      this.isShowTaskTypeColumn = this.csvUploadActiveTab === CsvUploadType.TASK.csvNo || this.csvUploadActiveTab === CsvUploadType.SORTING.csvNo
    },

    /**
     * アップロードタブを更新します。
     * @param {string} csvNo - アップロードタブのキー
     */
    updateCsvActiveTab(csvNo) {
      if (this.csvUploadActiveTab === csvNo) {
        return
      } else {
        this.csvUploadActiveTab = csvNo
        // CSVアップロードタブが 'task' または 'sorting' の場合にのみ、タスクタイプ列を表示する
        this.isShowTaskTypeColumn = csvNo === CsvUploadType.TASK.csvNo || csvNo === CsvUploadType.SORTING.csvNo
        localStorage.setItem(AppConstants.STORAGE_CSV_UPLOAD_TAB_ACTIVE, JSON.stringify(csvNo))
      }
      this.originalFileData = []
      this.initFileInput()
      this.filteredTaskTypeList = this.filterTaskTypeList(this.csvUploadActiveTab, this.taskTypeList)
    },

    /**
     * アップロード情報を取得します。
     */
    async getUpload() {
      try {
        const response = await this.$axios.get('/upload')
        const csvResults = response.data
        // 除外するCSVタイプをフィルタリング
        csvResults.mstCsvType
          .filter(val => val.csvNo !== 'result')
          .forEach(item => {
            this.csvInfoData[item.filenamePrefix] = item
          })
        const duplicateRecordsOperationMode = csvResults.duplicateRecordsOperationMode
        // デフォルトのタスクタイプ（-1 と -2）を除外して取得する
        this.taskTypeList = csvResults.taskTypeSettings
          .filter(task => !TASK_TYPE_DEFAULT.includes(task.taskType))
        this.filteredTaskTypeList = this.filterTaskTypeList(this.csvUploadActiveTab, this.taskTypeList)
        switch (duplicateRecordsOperationMode) {
          case AppConstants.DUPLICATE_RECORDS_OPERATION_MODE_REREGISTRATION:
            this.replacementMethod = AppConstants.DUPLICATE_RECORDS_OPERATION_MODE_REREGISTRATION_ST
            break
          case AppConstants.DUPLICATE_RECORDS_OPERATION_MODE_OVERWRITING:
            this.replacementMethod = AppConstants.DUPLICATE_RECORDS_OPERATION_MODE_OVERWRITING_ST
            break
          case AppConstants.DUPLICATE_RECORDS_OPERATION_MODE_ERROR:
            this.replacementMethod = AppConstants.DUPLICATE_RECORDS_OPERATION_MODE_ERROR_ST
            break
          default:
            this.replacementMethod = ''
        }
      } catch (error) {
        console.log(error)
      }
    },

    /**
     * アップロードを開始します。
     */
    async processCsvUpload() {
      this.copyFiles = []
      this.taskTypeSelectedList = []
      for (const item of this.originalFileData) {
        if (item.uploadStatus !== CSV_UPLOAD_STATUS_SUCCESS) {
          this.copyFiles.push(item.file)
        }
        this.taskTypeSelectedList.push(item.taskType)
        // ABC001 - CSVファイルでない場合 - ファイルのプレフィックスが正しくない場合
        if (item.isNotCsvFile || item.prefix === UNSPECIFIED_FILE_NAME_PREFIX) {
          return FlashMessage.getInstance().showErrorMsgWithErrorCode(
            ErrorCdMsgConstants.FUNC_CSV_FILE_ARE_UNSPECIFIED_PREFIX_ERR_CD,
            ErrorCdMsgConstants.FUNC_CSV_FILE_ARE_UNSPECIFIED_PREFIX_ERR_MSG
          )
        }
        // ABC002 - ファイルが空の場合
        if (item.isEmptyFile) {
          return FlashMessage.getInstance().showErrorMsgWithErrorCode(
            ErrorCdMsgConstants.FUNC_CSV_FILE_EMPTY_ERR_CD,
            ErrorCdMsgConstants.FUNC_CSV_FILE_EMPTY_ERR_MSG
          )
        }
        // ABC004 - タスクタイプが利用できない場合
        if (this.csvUploadActiveTab !== CsvUploadType.DEFAULT.csvNo && item.taskType === null) {
          return FlashMessage.getInstance().showErrorMsgWithErrorCode(
            ErrorCdMsgConstants.FUNC_CSV_FILE_TASK_TYPE_UNAVAILABLE_ERR_CD,
            ErrorCdMsgConstants.FUNC_CSV_FILE_TASK_TYPE_UNAVAILABLE_ERR_MSG
          )
        }
      }
      this.isUploadInProgress = true
      try {
        store.commit('setIsUploading', true)
        await this.prepareCsvUpload()
      } finally {
        store.commit('setIsUploading', false)
      }
    },

    /**
     * ダウンロードを行います。
     */
    async onDownloadErrorFile() {
      try {
        const data = this.originalFileData.find(f => { return f.uploadStatus === CSV_UPLOAD_STATUS_FAILED })
        const fileName = data && data.file && data.file.name ? 'ERROR_'.concat(data.file.name) : ''
        const response = await HTTPClient.getInstance().httpBlob.post(
          `/upload/download-file-error/?file-name=${RouterUtils.encodedUrlParam(fileName)}`
        )
        if (!response.data || !response.data.size) {
          // バックエンドから返ったきたCSVファイルnullだった場合
          FlashMessage.getInstance().showErrorMessage('ファイルをダウンロードしようとしましたが、データがありませんでした。')
          return
        }
        const blob = new Blob([response.data], {
          type: CSV_FILE_TYPE
        })
        // ダウンロードします
        saveAs(blob, fileName)
      } catch (error) {
        FlashMessage.getInstance().parseAndShowErrorMessage(error)
      }
    },

    /**
     * アップロードを準備します。
     */
    async prepareCsvUpload() {
      this.isShowDownloadIcon = false
      // アップロードするファイルがない場合、処理を中止しエラーメッセージを表示する
      if (!this.copyFiles.length) {
        this.isUploadInProgress = false
        return FlashMessage.getInstance().showErrorMessage('アップロードするファイルがありません。')
      }
      const uploadFile = this.copyFiles[0]
      const formData = new FormData()
      const activeUpload = Object.values(CsvUploadType).find(item => item.csvNo === this.csvUploadActiveTab)
      if (activeUpload) {
        const params = activeUpload.params(uploadFile, this.csvUploadActiveTab, this.taskTypeSelectedList[0])
        Object.entries(params).forEach(([key, value]) => {
          formData.append(key, value)
        })
      }
      let fileData = this.originalFileData.find(val => val.file.name === uploadFile.name)
      if (fileData) {
        fileData.uploadStatus = CSV_UPLOAD_STATUS_IMPORTING
      }
      const isReadableFile = await FileReaderUtils.readFileAsync(uploadFile)
      if (!isReadableFile) {
        this.isUploadInProgress = false
        if (fileData) {
          fileData.uploadStatus = CSV_UPLOAD_STATUS_FAILED
          fileData.hasErrorDetail = false
        }
        this.initFileInput()
        return
      }
      try {
        await this.$axios.post('/upload', formData)
        if (fileData) {
          fileData.uploadStatus = CSV_UPLOAD_STATUS_SUCCESS
        }
        this.copyFiles.shift()
        this.taskTypeSelectedList.shift()
        // アップロードするファイルが残っている場合、再帰呼び出し
        if (this.copyFiles.length) {
          await this.prepareCsvUpload()
        } else {
          this.isUploadInProgress = false
          this.initFileInput()
          return FlashMessage.getInstance().showSuccessMessage('アップロード完了。')
        }
      } catch (error) {
        this.isUploadInProgress = false
        const errObj = error && error.response && error.response.data
        const hasError = !!errObj && !!errObj.errCd
        if (fileData) {
          fileData.uploadStatus = CSV_UPLOAD_STATUS_FAILED
          fileData.hasErrorDetail = hasError && !(errObj && this.errCdsWithoutDetails.includes(errObj.errCd))
        }
        if (!hasError) {
          return
        }
        if (errObj.errMap) {
          this.errorMessages = Object.values(errObj.errMap).flat()
        }
        this.isShowDownloadIcon = !!errObj.errorFileExists
        this.initFileInput()
        FlashMessage.getInstance().showErrorMessage(
          errObj.errMsg || ErrorMessageUtils.buildErrorMessage(
            ErrorCdMsgConstants.FUNC_FAILED_CSV_UPLOAD_ERR_CD,
            ErrorCdMsgConstants.FUNC_FAILED_CSV_UPLOAD_ERR_MSG
          )
        )
      }
    },

    /**
     * ファイルを削除します。
     * @param {Object} file - ファイル
     */
    confirmAndDeleteCsvFile(file) {
      const deleteConfirm = confirm(`${file.name}を削除しますか？`)
      if (!deleteConfirm) return
      for (var key in this.originalFileData) {
        if (file.name === this.originalFileData[key].file.name) {
          this.originalFileData.splice(key, 1)
        }
      }
      this.initFileInput()
    },

    /**
     * ドラッグ&ドロップのステータスを処理します。
     * @param {Event} event - ドラッグ&ドロップイベント
     * @param {string} key - キー
     * @param {boolean} status - ステータス
     */
    processDragStatus(event, key, status) {
      if (status && event.dataTransfer.types === 'text/plain') {
        // ファイルではなく、html要素をドラッグしてきた時は処理を中止
        return false
      }
      this.isDragCsvFile = status ? key : null
    },

    /**
     * ドラッグ&ドロップから呼ばれる。
     * @param {Event} event - ドラッグ&ドロップイベント
     * @param {string} key - キー
     * @param {Object} image - 画像
     * @returns {boolean} ドラッグ&ドロップイベントが発生したかどうか
     */
    onDropCsvFile(event, key = '', image = {}) {
      // ドラッグ中のクラスを外しておく
      this.isDragCsvFile = null
      const fileList = event.target.files || event.dataTransfer.files
      // ファイルが無い時は処理を中止
      if (fileList.length === 0) {
        return false
      }
      this.originalFileData = []
      const taskType = this.filteredTaskTypeList.length ? this.filteredTaskTypeList[0].value : null
      for (let i = 0; i < fileList.length; i++) {
        const file = fileList[i]
        let createItem = this.generateSortItem(file.name)
        const isEmptyFile = !file.size
        const isNotCsvFile = file.type !== CSV_FILE_TYPE
        this.originalFileData.push({
          prefix: createItem.prefix,
          file: file,
          uploadStatus: CSV_UPLOAD_STATUS_INCOMPLETE,
          isEmptyFile: isEmptyFile,
          taskType: taskType,
          isNotCsvFile: isNotCsvFile
        })
      }
      this.originalFileData.sort((fileA, fileB) => {
        const sortItemA = this.generateSortItem(fileA.file.name)
        const sortItemB = this.generateSortItem(fileB.file.name)
        // ソート番号が同じ場合は、オプションの値を比較する
        return sortItemA.sortNo - sortItemB.sortNo ||
          sortItemA.optionalValue.toLowerCase().localeCompare(sortItemB.optionalValue.toLowerCase())
      })
    },

    /**
     * ソートアイテムを生成します。
     * @param {string} fileName - ファイル名
     * @returns {Object} ソートアイテム
     */
    generateSortItem(fileName) {
      const returnObj = { prefix: UNSPECIFIED_FILE_NAME_PREFIX, sortNo: 9999, optionalValue: '' }
      if (!this.isCsvFile(fileName)) {
        return returnObj
      }
      let hasUnderscore = fileName.includes(UNDERSCORE)
      let filenamePrefix = fileName.split(hasUnderscore ? UNDERSCORE : CSV_EXTENSION_REGEX)[0]
      let csvData = this.csvInfoData[filenamePrefix]
      if (this.csvUploadActiveTab === CsvUploadType.DEFAULT.csvNo && !csvData) {
        return returnObj
      }
      return {
        prefix: filenamePrefix,
        sortNo: csvData && csvData.csvOrder ? csvData.csvOrder : returnObj.sortNo,
        optionalValue: this.getOptionalValue(fileName, hasUnderscore)
      }
    },

    /**
     * タスクタイプリストをフィルタリングします。
     * @param {string} csvUploadActiveTab - アクティブなCSVタブのキー
     * @param {Array} taskTypeList - タスクタイプリスト
     * @returns {Array} フィルタリングされたタスクタイプリスト
     */
    filterTaskTypeList(csvUploadActiveTab, taskTypeList) {
      let filteredTaskTypeList = taskTypeList
      // 作業指示データの場合は、作業指示有無が1のタスクタイプのみを表示する
      if (csvUploadActiveTab === CsvUploadType.TASK.csvNo) {
        filteredTaskTypeList = filteredTaskTypeList.filter(task => task.workInstruction === WorkInstructionFlag.WORK_INSTRUCTION)
      }
      filteredTaskTypeList.sort((a, b) => a.sort - b.sort)
      return filteredTaskTypeList.map(task => ({
        value: task.taskType,
        text: `${task.taskType} : ${task.taskTypeName}`
      }))
    },

    /**
     * 指定されたファイル名がCSVファイルかどうかを判定します。
     * @param {string} filename - ファイル名
     * @returns {boolean} CSVファイルであればtrue、そうでなければfalse
     */
    isCsvFile(filename) {
      if (typeof filename !== 'string') {
        return false
      }
      return filename.toLowerCase().endsWith('.csv')
    },

    /**
     * ファイル名からオプションの値を取得します。
     * @param {string} fileName - ファイル名
     * @param {boolean} hasUnderscore - アンダースコアが含まれているかどうか
     * @returns {string} オプションの値
     */
    getOptionalValue(fileName, hasUnderscore) {
      const lowerCaseFilename = fileName.toLowerCase()
      if (hasUnderscore) {
        let firstUnderscoreIndex = lowerCaseFilename.indexOf(UNDERSCORE)
        let lastExtensionIndex = lowerCaseFilename.lastIndexOf(CSV_FILE_EXTENSION)
        let startIndex = firstUnderscoreIndex + UNDERSCORE.length
        return fileName.substring(startIndex, lastExtensionIndex)
      }
      let firstUnderscoreIndex = lowerCaseFilename.indexOf(CSV_FILE_EXTENSION)
      let lastExtensionIndex = lowerCaseFilename.lastIndexOf(CSV_FILE_EXTENSION)
      let startIndex = firstUnderscoreIndex + CSV_FILE_EXTENSION.length
      return fileName.substring(startIndex, lastExtensionIndex)
    },

    /**
     * ファイル入力を初期化します。
     */
    initFileInput() {
      const input = this.$refs.fileInput
      input.type = 'text'
      input.type = 'file'
    },

    /**
     * アップロードテーブルを表示するかどうかを判定します。
     * @returns {boolean} アップロードテーブルを表示するかどうか
     */
    isShowUploadTable() {
      return this.originalFileData.length > 0
    },

    /**
     * アップロードボタンを表示するかどうかを判定します。
     * @returns {boolean} アップロードボタンを表示するかどうか
     */
    isShowUploadButton() {
      return this.originalFileData.length > 0 &&
         !this.originalFileData.every(file => file.uploadStatus > CSV_UPLOAD_STATUS_IMPORTING)
    },

    /**
     * エラー変換を行います。
     * @param {Array} arr - 配列
     * @returns {Array} エラー変換された配列
     */
    errorConvert(arr) {
      var returnArr = [arr[1], arr[0]]
      returnArr.push(...arr.slice(2))
      return returnArr
    }
  }
}
</script>

<style lang="scss" scoped>
.csv-upload {
  overflow-y: auto;
  main {
    .csv-upload-tab {
      display: flex;
      justify-content: start;
      padding: 0.5rem;
      @include responsive-fs(12);
    }
    .csv-upload-table {
      margin-bottom: 1rem;
      .upload_table {
        border-bottom: 1px solid $border_color;
        thead {
          width: 100%;
          th {
            width: 20%;
            white-space: nowrap;
            height: 49px;
            font-weight: bold;
            text-align: center;
            @include responsive-fs(12);
            border-top: 3px solid $border_color;
            border-bottom: 3px solid $border_color;
            vertical-align: middle;
            padding: 0;
            span {
              display: flex;
              justify-content: center;
              align-items: center;
              @include textOverflowEllipsis(false, 1);
            }
          }
        }
        tbody {
          tr {
            width: 100%;
            td {
              width: 20%;
              height: 48px;
              @include responsive-fs(12);
              color: $base_text;
              vertical-align: middle;
              .file-name {
                .file-error-text {
                  display: flex;
                  justify-content: center;
                  white-space: nowrap;
                  align-items: center;
                  color: #B41B3E;
                }
              }
              .status {
                color: #fff;
                height: 25px;
                display: inline-block;
                width: auto;
                line-height: 24px;
                @include responsive-fs(13);
                border-radius: 6px;
                .download-icon {
                  padding-left: 15px;
                  height: 100%;
                  transform: translateY(25%);
                  cursor: pointer;
                }
              }
            }
            .task-type-column {
              max-width: 150px;
              /deep/ .multiselect {
                &__single {
                  align-items: center;
                  @include responsive-fs(12);
                }
                &--active,
                &--focus {
                  border: none;
                }
                &__tags {
                  border: none;
                }
                .multiselect__option {
                  @include responsive-fs(12);
                }
              }
            }
            .disabled {
              @include responsive-fs(12);
              color: #373944;
            }
            .delete_circle_btn {
              margin: 0;
              width: 58px;
              height: 34px;
              line-height: 0;
              background-color: #fff;
              .delete_icon {
                width: 13px;
              }
            }
            .delete_hidden_btn {
              visibility: hidden;
            }
          }
        }
      }
    }
    .btn_blue_round,
    .btn_gray_round {
      min-height: 42px;
      min-width: 200px;
      border-radius: 4px;
      margin-top: 15px;
      @include responsive-fs(16);
      display: flex;
      justify-content: center;
      align-items: center;
      white-space: nowrap;
    }
    .-drag {
      border: 2px dashed #e5e5e5;
      background: #f5f6f7;
    }
    .upload-area {
      height: 257px;
      background: #fff;
      border-radius: 4px;
      border: 2px dashed #e5e5e5;
      text-align: center;
      margin: 6px;
      p {
        @include responsive-fs(12);
        color: $base_text;
      }
      .btn_light_blue_round {
        width: 200px;
      }
      .drop {
        position: relative;
        top: 20%;
        img {
          width: 40px;
          margin-bottom: 20px;
        }
        .drag-drop-info {
          @include responsive-fs(12);
        }
        .text_blue {
          color: #155275 !important;
        }
        .upload_btn:hover {
          cursor: pointer;
          opacity: 0.7;
        }
      }
    }
    .errorMessage {
      @include responsive-fs(16);
    }
  }
}
/deep/ .modal-body {
  padding-top: 0px;
}
/deep/ .modal-header {
  border-bottom: none;
}
.material-symbols-outlined, .report-icon {
  @include responsive-fs(14, true);
  font-weight: bold !important;
}
</style>



// WEBPACK FOOTER //
// src/components/CsvUpload.vue